import styled, { CSSObject } from '@emotion/styled';

export const ContentWrapperColumn = styled.div(
  (): CSSObject => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  })
);
